import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { columns } from 'pages/orders/table/columns';
import { rows } from 'pages/orders/table/rows';
import { ROUTES } from 'shared/constants/routes';
import Tooltip from '@material-ui/core/Tooltip';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles({
  td: {
    fontSize: 11,
    padding: '13px 16px',
    '& img': {
      width: 50,
    },
    '& a': {
      color: '#337ab7',
      textDecoration: 'none',
    },
  },
  tr: {
    transition: 'all ease-out 0.25s',
    '&:nth-of-type(odd)': {
      background: 'linear-gradient(60deg, #fff, #eee)',
    },
    '&:nth-of-type(even)': {
      background: 'linear-gradient(-45deg, #fff, #eee)',
    },
  },
});

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      background: 'linear-gradient(60deg, #fff, #eee)',
    },
    '&:nth-of-type(even)': {
      background: 'linear-gradient(-45deg, #fff, #eee)',
    },
    '&:hover': {
      cursor: 'pointer',
      background: 'white',
      boxShadow: '10px 10px 30px #d9d9d9, -10px -10px 30px #d9d9d9',
      position: 'relative',
    },
  },
}))(TableRow);

const BlackCheckbox = withStyles({
  root: {
    color: '#000',
    padding: 0,
    '&$checked': {
      color: '#000',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const Orders = ({
  orders,
  onOrderSelect,
  category,
  voidOrder,
  copyOrder,
  toggleOrderForPayment,
  // getShopifyOrder,
}) => {
  const currency = useSelector((state) => state?.currency?.value);
  const classes = useStyles();
  const history = useHistory();
  const data = rows(orders, currency);

  const newColumns =
    category === 'PendingDetails'
      ? [
          ...columns,
          {
            id: 'void',
            label: 'Void',
            minWidth: 100,
          },
        ]
      : category === 'AwaitingPayment'
      ? [
          {
            id: 'checkbox',
            align: 'center',
          },
          ,
          ...columns,
          {
            id: 'copyOrder',
            label: 'Copy Order',
            minWidth: 100,
          },
          {
            id: 'vendorReferenceNumber',
            label: 'Vendor Reference Number',
          },
        ]
      : category === 'InProduction'
      ? [
          {
            id: 'checkbox',
            align: 'center',
          },
          ...columns,
          {
            id: 'vendorReferenceNumber',
            label: 'Vendor Reference Number',
          },
        ]
      : columns;

  return data?.length > 0 ? (
    data.map((row, index) => (
      <StyledTableRow
        key={`OrdersTable${index}`}
        hover
        tabIndex={-1}
        onClick={() => {
          if (_.isFunction(onOrderSelect)) {
            onOrderSelect(orders[index]);
            return;
          }
          if (orders[index]?.Store?.ShopName) {
            history.push(
              `${ROUTES.ORDER_DETAILS.LINK}/${
                orders[index].ID
              }/${encodeURIComponent(orders[index]?.Store?.ShopName)}`
            );
          } else {
            history.push(`${ROUTES.ORDER_DETAILS.LINK}/${orders[index].ID}`);
          }
        }}
      >
        {newColumns.map((column, columnIndex) => (
          <TableCell
            className={classes.td}
            key={`${column.id}tbody${columnIndex}${index}`}
            align={column.align}
            onClick={(e) => {
              if (column?.id === 'BuyerName' || column?.id === 'OrderId') {
                e.stopPropagation();
                e.preventDefault();
              }
            }}
          >
            {column.id === 'void' ? (
              <Tooltip
                title={`I don't want to fulfill this order by Big Oven Tees`}
              >
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    voidOrder(orders[index]);
                  }}
                  style={{
                    background: 'transparent',
                    width: '100%',
                    color: 'red',
                    border: '1px solid red',
                    textAlign: 'center',
                    padding: '3px 0px',
                    borderRadius: '5px',
                    fontSize: '14px',
                    cursor: 'pointer',
                  }}
                >
                  Void
                </div>
              </Tooltip>
            ) : column.id === 'TrackingNumber' ? (
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                }}
              >
                {row[column.id]}
              </span>
            ) : column.id === 'copyOrder' ? (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  copyOrder(orders[index]);
                }}
                style={{
                  background: 'transparent',
                  width: '100%',
                  color: '#000',
                  border: '1px solid #000',
                  textAlign: 'center',
                  padding: '3px 0px',
                  borderRadius: '5px',
                  fontSize: '14px',
                  cursor: 'pointer',
                }}
              >
                Duplicate Order
              </div>
            ) : column?.id === 'checkbox' ? (
              <div
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <BlackCheckbox
                  checked={orders[index]?.checked || false}
                  onChange={(e) => {
                    e.stopPropagation();
                    toggleOrderForPayment(index, e.target.checked);
                  }}
                />
              </div>
            ) : (
              row[column.id]
            )}
          </TableCell>
        ))}
      </StyledTableRow>
    ))
  ) : (
    <StyledTableRow key={`NodataFound`} hover tabIndex={-1}>
      <TableCell
        className={classes.td}
        key="tbodynodatafound"
        colSpan={newColumns.length}
      >
        No Data Found
      </TableCell>
    </StyledTableRow>
  );
};

export default Orders;
